import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import ManagePlayerQueries from "../../components/players/ManagePlayerQueries";
import { RouteConstants } from "../../constants/RouteConstants";

class PlayerQueryContainer extends Component {
  componentDidMount() {
    const { trackingHelper } = this.props.rootStore;
    trackingHelper.trackPageView(RouteConstants.PLAYER_QUERIES.title);
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="col-12 p-0 mb-4">
          <ManagePlayerQueries />
        </div>
      </div>
    );
  }
}

PlayerQueryContainer.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(PlayerQueryContainer));
